import { useTranslation } from '../../../../utils/useTranslation';
import ns from '../../translations';

export const AdBadge = () => {
  const { t } = useTranslation(ns);

  return <div className="vgp-ad-badge">{t('advertisement')}</div>;
};
